import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { IrfeProjetoService } from '../services/irfe-projeto.service';

@Injectable({
  providedIn: 'root'
})
export class IrfeProjetoResolver implements Resolve<boolean> {

  constructor(private service: IrfeProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AditivoIrfeResolver implements Resolve<boolean> {

  constructor(private service: IrfeProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let aditivo_id = route.queryParams['aditivo_id'];
    return this.service.getAditivoById(aditivo_id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AditivoIrfeInitResolver implements Resolve<boolean> {

  constructor(private service: IrfeProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getAditivoInit(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class TiposAditivosIrfeListResolver implements Resolve<boolean> {

  constructor(private service: IrfeProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getTiposAditivosList();
  }
}
